import script from "./InstantTransactionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantTransactionPage.vue?vue&type=script&setup=true&lang=js"

import "./InstantTransactionPage.vue?vue&type=style&index=0&id=7cd43e61&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd43e61"]])

export default __exports__